const systemData = state => state;

const systemSoftPhoneSettings = (state, getters) => {
  return getters.systemData.softPhoneSettings;
};

const productVersion = state => state.productVersion;

const interactionTypes = state => state.interactionTypes;

const allAgentStates = state => state.allAgentStates;

export default {
  systemData,
  productVersion,
  interactionTypes,
  systemSoftPhoneSettings,
  allAgentStates
};
